import { render } from "./AddAssign.vue?vue&type=template&id=2319e136&ts=true"
import script from "./AddAssign.vue?vue&type=script&lang=ts"
export * from "./AddAssign.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__